import { render, staticRenderFns } from "./ProjectMembershipEditor.vue?vue&type=template&id=6c5ccfc5&"
import script from "./ProjectMembershipEditor.vue?vue&type=script&lang=js&"
export * from "./ProjectMembershipEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports